import React, { useEffect, useState } from 'react'
import GoogleDrivePicker from "google-drive-picker";
import { API_URL, checkURL } from './../constants'
import { useContext } from './../Context'
import axios from 'axios'

const DriveUpload = ({ children }) => {
    // Replace with your Google API client ID
    const GOOGLE_CLIENT_ID = '243270612805-sfgkb6s6vca7f85m1bvvps7oj6algu3b.apps.googleusercontent.com';
    const DEVELOPER_KEY = 'AIzaSyDs3yD3BvKxzLp8Phv3_iJ6jCXdQkPvnJQ';

    const { globalState, setGlobalState } = useContext()

    const [authTocken, setauthTocken] = useState("");
    const [openPicker, authRes] = GoogleDrivePicker();

    const onFileUpload = async (driveFile) => {

        const link = `https://drive.google.com/thumbnail?id=${driveFile.id}&sz=w1000`;

        const file = {
            link,
            name: driveFile.name
        }

        await setGlobalState({
            ...globalState,
            uploadMode: 'drive',
            selectedFile: file,
            isMatchLoading: true,
        })

        await axios
            .post(`${API_URL}/check-image-by-url-against-library`, file)
            .then(response => {
                console.log(response)
                setGlobalState({
                    ...globalState,
                    match: response.data.closestMatch,
                    topMatches: response.data.topMatches,
                    timeTaken: response.data.timeTaken,
                    librarySize: response.data.librarySize
                })
            })
            .catch(error => {
                alert('Ooops something went wrong, please make sure that you are the owner of the image in Google Drive and it has been publicly shared first: Find your image file in Google Drive. Open the vertical ellipsis menu by selecting the icon, then select Share. This opens the Share window. Under General access, select Anyone with the link from the dropdown.')
                console.error(error)

                setGlobalState({
                    ...globalState,
                    selectedFile: null,
                    isMatchLoading: false
                })
            })
    }

    const handlePickerOpen = () => {
        openPicker({
            clientId: GOOGLE_CLIENT_ID,
            developerKey: DEVELOPER_KEY,
            viewId: "DOCS_IMAGES",
            token: authTocken,
            showUploadView: false,
            showUploadFolders: false,
            supportDrives: true,
            multiselect: false,
            callbackFunction: (data) => {
                if (data.action === "cancel") {
                    console.log("User clicked cancel/close button");
                } else if (data.docs && data.docs.length > 0) {
                    onFileUpload(data.docs[0])

                }
            }
        });
    };

    useEffect(() => {
        if (authRes) {
            setauthTocken(authRes.access_token);
        }
    }, [authRes]);

    return (
        <div className="cursor-pointer" onClick={handlePickerOpen}>
            {children}
        </div>
    )

}
export default DriveUpload